import instance from '@/http/http.js';

//估值与分为
function stockValuation(params){
    return new Promise((resolve,reject)=>{
        instance.post('/Stock/stockValuation',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//成长能力
function stockGrowthAbility(params){
    return new Promise((resolve,reject)=>{
        instance.post('/Stock/stockGrowthAbility',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//利润率
function stockProfitMargin(params){
    return new Promise((resolve,reject)=>{
        instance.post('/Stock/stockProfitMargin',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//利润率
function stockDupontAnalysis(params){
    return new Promise((resolve,reject)=>{
        instance.post('/Stock/stockDupontAnalysis',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//利润率
function stockCapitalReturn(params){
    return new Promise((resolve,reject)=>{
        instance.post('/Stock/stockCapitalReturn',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//费用率
function stockCapitalCost(params){
    return new Promise((resolve,reject)=>{
        instance.post('/Stock/stockCapitalCost',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//股东户数
function stockSHNumber(params){
    return new Promise((resolve,reject)=>{
        instance.post('/Stock/stockSHNumber',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//基础信息实时行情
function stockBasicData(params){
    return new Promise((resolve,reject)=>{
        instance.post('/Stock/stockBasicData',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//简介 概况
function stockIntroduce(params){
    return new Promise((resolve,reject)=>{
        instance.post('/Stock/stockIntroduce',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//主营构成
function stockMainBusiness(params){
    return new Promise((resolve,reject)=>{
        instance.post('/Stock/stockMainBusiness',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//PE/PB
function stockPePbBand(params){
    return new Promise((resolve,reject)=>{
        instance.post('/Stock/stockPePbBand',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

export {
  stockBasicData,
  stockCapitalCost,
  stockCapitalReturn,
  stockDupontAnalysis,
  stockGrowthAbility,
  stockIntroduce,
  stockMainBusiness,
  stockPePbBand,
  stockProfitMargin,
  stockSHNumber,
  stockValuation,
};